import React from 'react';

import { Container, Heading, Content } from './SupportBlock.styled';

export interface Props {
    heading?: string | React.ReactNode;
    children?: string | React.ReactNode;
    backgroundColor?: string;
    headingStyle?: 'h2' | 'h3';
    showBorder?: boolean;
}

const SupportBlock: React.FC<Props> = props => {
    const { heading, headingStyle = 'h2', children, backgroundColor, showBorder = true } = props;

    return (
        <Container $backgroundColor={backgroundColor} $showBorder={showBorder}>
            {typeof heading === 'string' ? (
                <Heading $headingStyle={headingStyle}>{heading}</Heading>
            ) : (
                heading
            )}
            <Content>{children}</Content>
        </Container>
    );
};

export default SupportBlock;
